import {
  Box,
  Flex,
  Grid,
  GridItem,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { backendTechs, frontTechs } from "./data";
import Zoom from "react-reveal/Zoom";
const Skills = () => {
  return (
    <section
      id="skills"
      style={{
        backgroundColor: "black",
        border: "1px solid black",
        height: "auto",
      }}
    >
      <div
        style={{
          textAlign: "center",
          fontSize: "40px",
          marginTop: "-30px",
          marginBottom: "40px",
          fontWeight: "bold",
        }}
      >
        <h1> Skills</h1>
      </div>
      <Box>
        <Flex
          bg={"teal"}
          flexDir={{ base: "column", lg: "row" }}
          minH={"60vh"}
          justify={"space-around"}
          // marginBottom={"60px"}
        >
          <Box>
            <Text
              textAlign={"center"}
              fontSize="2.0rem"
              color={"black"}
              marginBottom={"20px"}
              marginTop={"20px"}
            >
              FrontEnd
            </Text>
            <Grid
              templateColumns={{
                base: "repeat(3, 1fr)",
                md: "repeat(4, 1fr)",
                lg: "repeat(4,1fr)",
                xl: "repeat(5,1fr)",
              }}
              gap={4}
              p="1rem"
              marginBottom={"30px"}
            >
              {frontTechs.map((item) => {
                return (
                  <Zoom>
                    <Flex
                      key={item.id}
                      className="icon-shadow skills-card"
                      padding="4px"
                      paddingBottom={"2px"}
                      px="0.5rem"
                      borderRadius={"7px"}
                      flexDir="column"
                      justify={"center"}
                      // boxShadow={item.boxShadow}
                      border={"2px solid  #92bcb5"}
                      align="center"
                      transition={"all 0.3s "}
                      bg={"black"}
                    >
                      <Image
                        width="60px"
                        className="skills-card-img"
                        src={item.image}
                      />
                      <Text className="skills-card-name" color={item.color}>
                        {item.name}
                      </Text>
                    </Flex>
                  </Zoom>
                );
              })}
            </Grid>
          </Box>
          <Box>
            <Text
              textAlign={"center"}
              fontSize="2.0rem"
              color={"black"}
              marginBottom={"20px"}
              marginTop={"20px"}
            >
              BackEnd
            </Text>
            <Grid
              templateColumns={{
                base: "repeat(3, 1fr)",
                md: "repeat(4, 1fr)",
                lg: "repeat(4,1fr)",
                xl: "repeat(5,1fr)",
              }}
              gap={4}
              p="1rem"
            >
              {backendTechs.map((item) => {
                return (
                  <Zoom>
                    <Flex
                      key={item.id}
                      className="icon-shadow skills-card"
                      padding="4px"
                      paddingBottom={"2px"}
                      px="0.5rem"
                      borderRadius={"7px"}
                      flexDir="column"
                      justify={"center"}
                      border={"2px solid  #92bcb5"}
                      // boxShadow={item.boxShadow}
                      align="center"
                      transition={"all 0.3s "}
                      bg={"black"}
                    >
                      <Image
                        width="60px"
                        className="skills-card-img"
                        src={item.image}
                      />
                      <Text className="skills-card-name" color={item.color}>
                        {item.name}
                      </Text>
                    </Flex>
                  </Zoom>
                );
              })}
            </Grid>
          </Box>
        </Flex>
      </Box>
    </section>
  );
};

export { Skills };
